//
//
//
//
//
//
//
//
//
//
//
//
//

import FreeActivityQuantityDialog from './freeActivityQuantityDialog.vue';
export default {
  name: 'FreeActivityVerifyDialog',
  components: {
    FreeActivityQuantityDialog: FreeActivityQuantityDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentState: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    submitting: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  }
};